import { restClient } from '@/Core'

/**
 * Fire-and-forget "typing" signal: the backend broadcasts typing:start to
 * the other participants, no state is stored anywhere. The caller throttles
 * (keep-alive ~4s) and silently ignores failures/429 — the indicator is
 * cosmetic and must never surface errors.
 */
export const SendTypingTask = async (chatId: string): Promise<void> => {
    await restClient.post(`/services/chat/chats/${chatId}/typing`, { json: {} })
}
